import {useDisclosure} from '@mantine/hooks';
import Head from 'next/head';
import type {GetCompanyInfoResponse} from '../../../../../core/repositories/companiesRepository';
import type {GetCompanyDetailResponse} from '../../../../../core/repositories/companyDetailRepository';
import {NoLoginAlertModal} from '../../../../../shared/components/NoLoginAlertModal';
import {createBreadCrumbsStructuredData} from '../../../../../shared/services/createBreadCrumbsStructuredData';
import {createJsonLdHtml} from '../../../../../shared/services/createJsonLdHtml';
import {CompanyHeaderSP} from './CompanyHeaderSP';

type Props = {
  companyInfo: GetCompanyInfoResponse;
  companyDetail: GetCompanyDetailResponse;
  companyName?: string;
  industryName?: string;
  industryCategoryName?: string;
  companyLogoURL?: string;
  mainPhotoURL?: string;
  vimeoId?: string;
  crumbIndustryName?: string;
  industryIds?: number[];
  industryCategoryId?: number;
  followCount: number;
  isFollowed: boolean;
  onFollow: () => void | Promise<void>;
  entryURL?: string;
  recruitingFairRegistrationURL?: string;
  isValid: boolean;
  availableGraduationYears?: number[];
  year: string;
  isEngineerCompany: boolean;
  openTableOfContentsModal: () => void;
};

export const CompanyHeaderWrapperSp: React.FC<Props> = ({
  companyInfo,
  companyDetail,
  companyName = '',
  industryName,
  industryIds,
  companyLogoURL,
  mainPhotoURL,
  vimeoId,
  crumbIndustryName = '',
  industryCategoryId,
  isFollowed,
  followCount,
  onFollow,
  entryURL,
  recruitingFairRegistrationURL,
  isValid,
  availableGraduationYears,
  year,
  isEngineerCompany,
  openTableOfContentsModal,
}) => {
  const [opened, {close}] = useDisclosure(false);
  const crumbsHref = isEngineerCompany
    ? '/company/industry/engineer'
    : `/company/industry/${industryCategoryId}${industryIds && industryIds?.length > 0 ? `?industryIDs=${industryIds.join(',')}` : ''}`;

  const crumbs = [
    {label: 'Home', href: '/'},
    {label: '企業を探す', href: '/company'},
    {
      label: isEngineerCompany ? 'エンジニア' : crumbIndustryName,
      href: crumbsHref,
    },
    {label: companyName, href: `/company/${companyInfo.id}`},
  ];

  return (
    <div>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={createJsonLdHtml(
            createBreadCrumbsStructuredData(crumbs),
          )}
        />
      </Head>
      <CompanyHeaderSP
        crumbsHref={crumbsHref}
        companyName={companyName}
        industryName={industryName ?? ''}
        isEngineerCompany={isEngineerCompany}
        crumbIndustryName={crumbIndustryName}
        year={year}
        availableGraduationYears={availableGraduationYears ?? []}
        mainPhotoURL={mainPhotoURL}
        vimeoId={vimeoId}
        isValid={isValid}
        openTableOfContentsModal={openTableOfContentsModal}
        companyLogoURL={companyLogoURL}
        companyId={companyInfo.id}
        companyFollowerCount={companyInfo.followerCount}
        recruitingFairRegistrationURL={recruitingFairRegistrationURL}
        entryURL={entryURL}
        isFollowed={isFollowed}
        followCount={followCount}
        onFollow={onFollow}
        workAttractiveConditions={
          companyDetail.metaData.workAttractiveConditions ?? []
        }
      />

      <NoLoginAlertModal opened={opened} onClose={close} />
    </div>
  );
};
